import { createStyles } from "@mantine/core";

const bgColor = "rgba(242, 242, 242, 0.6)";

const useStyles = createStyles((theme) => ({
  confirmationModal: {
    "& .mantine-19pz3dh": {
      display: "none",
    },
    "& .mantine-Modal-body": {
      padding: 0,
    },
    "& .mantine-Paper-root": {
      overflow: "initial",
    },
  },
  wrapper: {
    width: "100%",
    padding: "30px 30px",
  },

  saveButton: {
    display: "flex",
    gap: "10px",
    "& button": {
      marginTop: "20px",
      borderRadius: "5px",
      background: "color-mix(in srgb, var(--app-primary) 85%, transparent)",
      width: "100%",
      height: "40px",
      color: "#000",
      paddingInline: "10px",

      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "25px",

      "&:hover": {
        background: "color-mix(in srgb, var(--app-primary) 85%, transparent)",
      },
    },
  },
}));

export default useStyles;
